module.exports = __webpack_public_path__ + "img/Middle-2-Bevel-Attachment-28.fc638d59.png";